import {Row, Col, Card, Button, Input, Form, Badge, Tabs, Spin} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { useLocation, useNavigate, useParams } from "react-router";
import apiPath from "../../constants/apiPath";
import { Link } from "react-router-dom";
import languages from "../../config/language";
import DescriptionEditor from '../../components/DescriptionEditor';
import { ArrowLeftIcon, CheckLineIcon } from "lucide-react";
const { TabPane } = Tabs;

function AddEdit() {

    const sectionName   =   "CMS";
    const routeName     =   "cms";

    const { id }        =   useParams();
    const isEdit        =   Boolean(id);

    const api = {
        addEdit   :  apiPath.addEditCms,
        view      :  apiPath.viewCms,
    }
    
    const location                          =   useLocation();
    const [form]                            =   Form.useForm();
    const { request }                       =   useRequest()
    const [loading, setLoading]             =   useState(false)
    const [fetching, setFetching]           =   useState(false);
    const navigate                          =   useNavigate();
    const [validationStatus, setValidationStatus] = useState({});
 
    const handleFieldChange = (data, lang, type) => {
        const name                  =   form.getFieldValue(`${lang}_name`);
        const description           =   form.getFieldValue(`${lang}_description`);
        const isDescriptionEmpty    =   !description || (description.trim() === '<p></p>' || description.trim() === "");
        setValidationStatus(prevStatus => ({
            ...prevStatus, 
            [lang]: !!name && !isDescriptionEmpty
        }));
    }

    const fetchData = (id) => {
        setFetching(true);
        request({
            url: api.view + "/" + id,
            method: 'GET',
            onSuccess: (response) => {
                const { data } = response;
                form.setFieldsValue({ ...data });
                setFetching(false);
            },
            onError: (error) => {
                setFetching(false);
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    useEffect(() => {
        const initialValidationStatus = {};
        
        languages.forEach(lang => {
            initialValidationStatus[lang.short] = !!form.getFieldValue(`${lang.short}_name`) && !!form.getFieldValue(`${lang.short}_description`);
        });

        setValidationStatus(initialValidationStatus);
    }, [])

    const onCreate = (values) => {

        const payload = {
            ...values
        };

        setLoading(true)
        request({
            url: isEdit ? `${api.addEdit}/${id}` : api.addEdit,
            method: 'POST',
            data: payload,
            onSuccess: (data) => {
                setLoading(false)
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS)
                    navigate(`/${routeName}`);
                } else {
                    ShowToast(data.message, Severty.ERROR)
                }
            },
            onError: (error) => {
                ShowToast("Something went wrong, Please try again later", Severty.ERROR)
                setLoading(false)
            },
        })
    };
    
    useEffect(() => {
        if (isEdit) fetchData(id);
    }, [id]);
      
    return (
        <Card title={`${isEdit ? "Edit" : "Add New"} ${sectionName}`}>
            
            <Spin spinning={fetching} tip="Loading CMS details...">
                
                <Form className="edit-page-wrap" form={form} onFinish={onCreate} autoComplete="off" layout="verticle" name="blog_form">
                    
                    <Row gutter={[24, 0]}>

                        <Col span={24} xs={24} sm={24} md={24}>
                
                            <Tabs defaultActiveKey={languages[0].short}>
                                
                                {languages.map(lang => (

                                    <TabPane tab={<span>{lang.long} {validationStatus[lang.short] === false && <Badge dot color="red" />}</span>} key={lang.short}>

                                        <Form.Item label={`Name (${lang.long})`} name={`${lang.short}_name`}
                                            rules={[
                                            ...(lang.short === 'en' ? [
                                                { required: true, message: `Please enter the name in ${lang.long}!` }
                                            ] : []),
                                            { max: 100, message: "Name should not contain more than 100 characters!" },
                                            { min: 2, message: "Name should contain at least 2 characters!" },
                                            ]}
                                            initialValue={form.getFieldValue(`${lang.short}_name`)}
                                            onChange={(data) => handleFieldChange(data, lang.short, 'title')}
                                        >

                                            <Input autoComplete="off" placeholder={`Enter name in ${lang.long}`} />
                                        </Form.Item>

                                        <Form.Item label={`Description (${lang.long})`} name={`${lang.short}_description`}
                                            rules={[
                                                { required: lang.short === 'en', message: `Please enter the description in ${lang.long}!` },
                                            ]}
                                            initialValue={form.getFieldValue(`${lang.short}_description`)}
                                        >
                                            <DescriptionEditor value={form.getFieldValue(`${lang.short}_description`)} placeholder={`Enter Description in ${lang.long}`} onChange={(data)=> handleFieldChange(data, lang.short, 'description')} />

                                        </Form.Item>
                                    </TabPane>
                                ))}
                            </Tabs>
                        </Col>
                    </Row>
                            
                    <Form.Item className="btn-row float-right mt-3">
                        <Link className="ant-btn ant-btn-secondary" to={`/${routeName}${location.search}`}>
                        
                        <ArrowLeftIcon size={15} /> Back</Link>
                        
                        <Button type="primary" loading={loading} htmlType="submit">
                            <CheckLineIcon size={15} /> {isEdit ? "Update" : "Submit"}
                        </Button>
                    </Form.Item>
                </Form>

            </Spin>
        </Card>
    )
}

export default AddEdit;